export const adminFieldClass =
  "mt-1 w-full rounded-lg border bg-background px-3 py-2 text-sm text-primary";
export const adminLabelClass = "block text-sm text-primary";
